<template>
  <div class="CoverAllWindow">
    <div>
      <img src="@/assets/oops.jpg" style="width: 300px; margin-bottom:40px">
    </div>
     
    <div class="error-header">
      <svg class="info-icon" viewBox="0 0 24 24">
        <path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
      </svg>
      Something went wrong with the Whiteboard
    </div>
    <div>Please close the window and try opening it from the call again.</div>
    <div class="error-code">{{errorCode}}</div>
  </div>
</template>

<script type="text/babel">
export default {
  computed: {
    errorCode () {

      return (this.$route.params.code || '').toUpperCase();
    } 
  }
}
</script>

<style scoped>

  .CoverAllWindow {
    display:flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    font-family: 'AzoSans-Light'
  }

  .error-header { 
    font-weight: 800;
    font-size: 1.2rem;
    display: flex;
  }

  .CoverAllWindow > div {
    line-height: 30px
  }

  .info-icon {
    width:24px;
    height:24px; 
    margin-right:5px;
    margin-bottom:3px; 
    color: orange;
    cursor:pointer;
  }

  .error-code {
    font-size: .7rem;
    color: red;
    font-weight: 600;
  }
</style>
